import React from "react";

function MenuBar() {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 13.5C6 12.6716 6.67157 12 7.5 12H29.5C30.3284 12 31 12.6716 31 13.5C31 14.3284 30.3284 15 29.5 15H7.5C6.67157 15 6 14.3284 6 13.5Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 22.5C6 21.6716 6.67157 21 7.5 21H29.5C30.3284 21 31 21.6716 31 22.5C31 23.3284 30.3284 24 29.5 24H7.5C6.67157 24 6 23.3284 6 22.5Z"
        fill="black"
      />
    </svg>
  );
}

export default MenuBar;
